// import L, { polyline, marker, tileLayer } from "leaflet";
import { useMap } from "react-leaflet";
import { useEffect } from "react";

import betterWms from "./L.TileLayer.BetterWMS";
import * as WMS from "leaflet.wms";

function BetterWMS(props) {
  const map = useMap();
  const { url, options, layers, onShow } = props;
  console.log(onShow);
  const source = WMS.source(url, options);

  //   const layer = props.layer;

  useEffect(() => {
    const layer = betterWms(url, {
      layers: layers.join(","),
      format: options.format ? options.format : "image/png",
      info_format: "text/plain",
      transparent: true,
      attribution: "Some test",
      zIndex: options.zIndex ? options.zIndex : 10000,
      version: options.version,
      opacity: options.opacity,
      onShow: onShow !== undefined ? (text) => onShow(text) : null,
    });

    layer.addTo(map);
    //   source.getLayer(name).addTo(map);
    // }

    return () => {
      map.removeLayer(layer);
      //   map.removeLayer(wmsLayer);
      //   map.removeControl(control);
    };
  }, [
    layers,
    map,
    source,
    url,
    onShow,
    options.zIndex,
    options.opacity,
    options.format,
    options.version,
  ]);

  return null;
}

export default BetterWMS;
